import { AnalyticsModel } from '../config/types';

type PortableAnalyticsModel = {
  name: string;
  code: string;
  language: string;
  tags: AnalyticsModel['tags'];
  sections: AnalyticsModel['sections'];
};

const buildPortableModel = (model: AnalyticsModel): PortableAnalyticsModel => ({
  name: model.name,
  code: model.code,
  language: model.language,
  tags: {
    instructions: model.tags.instructions ?? null,
    groups: model.tags.groups.map((group) => ({
      code: group.code,
      name: group.name,
      type: group.type,
      instructions: group.instructions,
      selection_mode: group.selection_mode,
      required: group.required,
      tags: group.tags.map((tag) => ({
        code: tag.code,
        name: tag.name,
        instructions: tag.instructions,
        explain: tag.explain,
      })),
    })),
  },
  sections: (model.sections ?? []).map((section) => ({
    code: section.code,
    name: section.name,
    kind: section.kind,
    instructions: section.instructions,
  })),
});

const sanitizeFilenameSegment = (segment: string): string =>
  segment.replace(/[^a-z0-9_-]+/gi, '_').replace(/^_+|_+$/g, '') || 'model';

export const exportAnalyticsModelToJson = (model: AnalyticsModel): void => {
  const portable = buildPortableModel(model);
  const blob = new Blob([JSON.stringify(portable, null, 2)], {
    type: 'application/json',
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  const filenameCode = sanitizeFilenameSegment(model.code);
  const filenameLanguage = sanitizeFilenameSegment(model.language);

  link.href = url;
  link.download = `${filenameCode}_${filenameLanguage}.json`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
